export default {
	id: 'SIMPLE_UPGRADE_6M_107_95',
	providers: {
		stripe: '',
		braintree: '',
		paltaMap: {
			USD: 'simple_premium_6m_107_95_usd',
			EUR: 'simple_premium_6m_107_95_eur',
			GBP: 'simple_premium_6m_107_95_gbp',
			AUD: 'simple_premium_6m_149_aud',
			CAD: 'simple_premium_6m_149_cad',
			SEK: 'simple_premium_6m_1199_sek',
			BRL: 'simple_premium_6m_239_brl',
			DKK: 'simple_premium_6m_779_dkk',
			NOK: 'simple_premium_6m_1199_nok',
			MXN: 'simple_premium_6m_1799_mxn',
			TRY: 'simple_premium_6m_3699_try',
			ARS: 'simple_premium_6m_143990_ars',
			COP: 'simple_premium_6m_437990_cop',
			CLP: 'simple_premium_6m_104790_clp',
		},
		primer: 'prd_nC3DoQzhK2wH',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 6,
		intro_period_type: 'month',
		next_period_value: 6,
		next_period_type: 'month',
	},
	trial: null,
	subscription: {
		interval: 'month',
		intervalCount: 6,
		priceMap: {
			USD: 107.95,
			EUR: 107.95,
			GBP: 107.95,
			AUD: 149,
			CAD: 149,
			SEK: 1199,
			BRL: 239,
			DKK: 779,
			NOK: 1199,
			MXN: 1799,
			TRY: 3699,
			ARS: 143990,
			COP: 437990,
			CLP: 104790,
		},
	},
	options: ($t) => ({
		barChartTooltip: $t('activity_upgrade.6mo.bar_chart_tooltip'),
		barChartLeftLabel: $t('activity_upgrade.6mo.bar_chart_left_label'),
		barChartRightLabel: $t('activity_upgrade.6mo.bar_chart_right_label'),
	}),
}
